import styled from 'styled-components';

export const QuestionsContainer = styled.div`
  box-sizing: border-box;
  overflow: hidden;
`;

export const NoResults = styled.h3`
  margin: 0;
`;
